module.exports = __webpack_public_path__ + "img/bayern.f252944.webp";